import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface Appointment {
  id: number;
  title: string;
  startTime: Date;
  endTime: Date;
  location: string;
  description: string;
  userGuid: string;
  projectId?: number; // Optional, included for project context
}

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
  private apiUrl = 'api/appointments'; // Adjust to your API base URL, e.g., 'http://localhost:5000/api/appointments'

  constructor(private http: HttpClient) {}

  // Get all appointments for a specific project
  getAppointments(projectId: number): Observable<Appointment[]> {
    return this.http.get<Appointment[]>(`${this.apiUrl}?projectId=${projectId}`).pipe(
      catchError(this.handleError)
    );
  }

  // Get a single appointment by ID
  getAppointment(id: number): Observable<Appointment> {
    return this.http.get<Appointment>(`${this.apiUrl}/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  // Create a new appointment
  createAppointment(appointment: Appointment): Observable<Appointment> {
    return this.http.post<Appointment>(this.apiUrl, appointment).pipe(
      catchError(this.handleError)
    );
  }

  // Update an existing appointment
  updateAppointment(id: number, appointment: Appointment): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, appointment).pipe(
      catchError(this.handleError)
    );
  }

  // Delete an appointment
  deleteAppointment(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  // Error handling
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}